// GitHub API base URL for repositories
const GITHUB_API_BASE_URL = 'https://api.github.com/repos';

// Specific repository URLs
export const REPO_URLS = {
  CONTRIBUTORS: `${GITHUB_API_BASE_URL}/saurabhbakolia/SCROLLME--ECOMMERCE-WEBSITE/contributors?per_page=100`,
  REPO_DETAILS: `${GITHUB_API_BASE_URL}/saurabhbakolia/SCROLLME--ECOMMERCE-WEBSITE`,
};
